<template>
    <div class="InputView u-InputMarginView" :class="[modes.map((m) => `InputView--${m}`),
    { 'InputView--error': isError && required },
    { 'InputView--error': isError }]" :style="{ width: width }">
        <span class="InputViewRequired" v-if="required">*</span>
        <label class="InputViewLabel" :for="`InputView-input-${_uid}`" v-if="title">
            {{ title }}
        </label>
        <input class="InputViewInput" :type="type" v-model="innerValue" :id="`InputView-input-${_uid}`"
            :placeholder="placeholder" :style="{ height: height, width: width }" />
        <button class="InputViewButton" v-if="isGenerateSlug" @click="() => this.$emit('change')">Сгенерировать</button>
    </div>
</template>

<script>
export default {
    name: 'InputView',
    mixins: [mixins.ValidationComponentMixin],
    props: {
        title: { type: String, default: '' },
        required: { type: Boolean, default: false },
        value: { type: [Object, String, Number], default: '' },
        type: { type: String, default: 'text' },
        placeholder: { type: String, default: 'Текст' },
        inline: { type: Boolean, default: false },
        modes: { type: Array, default: () => [] },
        height: { type: String, default: '40px' },
        width: { type: String, default: '100%' },
        isError: { type: Boolean, default: false },
        isGenerateSlug: { type: Boolean, default: false },
    }
};
</script>

<style lang="less">
@import "~styles/const.less";

@r: .InputView;

@{r} {
    position: relative;
    margin-top: 25px;
    width: 100%;

    &Required {
        color: #A6A6A6;
        position: absolute;
        bottom: 9px;
        left: -23px;
    }

    &Label {
        color: black;
        font-size: 12px;
        line-height: 16px;
    }

    &Input {
        display: block;
        width: 100%;
        outline: none;
        border: 1px solid #B3B3B3;
        padding: 12px 15px;
        font-weight: @regular;
        color: @color-black;
        background-color: transparent;
        font-size: 12px;
        line-height: 16px;
        margin-top: 10px;

        &::placeholder {
            color: #B3B3B3;
        }
    }

    &Button {
        position: absolute;
        right: 0;
        bottom: 0;
        padding: 12px 15px;
        background-color: black;
        color: white;
        cursor: pointer;
        transition: opacity .3s ease;

        &:hover {
            opacity: .7;
        }
    }

    &.rubric, &.client {
        margin: 0;

        @{r}Input {
            margin: 0;
            border-color: transparent;
        }
    }

    &--error {
        .InputViewRequired {
            color: @color-red;
        }

        .InputViewInput {
            border-color: #F00;
        }
    }
}

.u-ShowErrors .InputView.u-ErrorView .InputViewInput {
    border-color: red;
}
</style>
